// extracted by mini-css-extract-plugin
export default {"pageDefault":"lincd_server_utils_Body_pageDefault"};